import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { WorkOrderDto } from 'src/api';

export interface WorkOrdersState extends EntityState<WorkOrderDto, number> {
  filters: {
    state: string | null;
    searchTerm: string | null;
  };
}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'workorders', cache: { ttl: 3600000 } })
export class WorkOrdersStore extends EntityStore<WorkOrdersState> {
  constructor() {
    super({
      filters: {
        searchTerm: null,
        state: 'Unassigned',
      },
    });
  }
}
